/*
    Add realization for Dark/Light Theme and show slider on pages
*/
export enum PageType {
    Login = 'Login',
    Registration = 'Registration',
    ForgotPassword = 'ForgotPassword',
    Error = 'Error',
}

export enum AccountType {
    Business = 'business',
    Individual = 'individual'
}

export enum KybPages {
    CheckKyb = 'check-kyb',
    VerificationPending = 'verification-pending'
}
